module.exports = __webpack_public_path__ + "static/timber-m8-logo-0117f069b9b9ec079449c1bc789c6218.png";